import React, { useState, useEffect } from 'react';
import { Box , Typography, Table, TableBody, TableContainer, TableHead, TableRow, Paper, CircularProgress } from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import { grey } from '@mui/material/colors';

import Nuevocliente from './Nuevocliente';
import Deletecliente from './Deletecliente';
import Celda from './Celda';  
import Editarcliente from './Editarcliente'; 
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneEnabledOutlinedIcon from '@mui/icons-material/PhoneEnabledOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';

import BASE_URL from '../../config'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: grey[100],
    color: theme.palette.common.black,
  }
}));

export default function ClientesPage() {
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchClientes = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/clientes/`);
      if (!res.ok) throw new Error("Error en la red o 404");
      const data = await res.json();
      const normalizedData = Array.isArray(data) ? data.map(c => ({
        ...c,
        equipo: Array.isArray(c.equipo) ? c.equipo : []
      })) : [];
      setClientes(normalizedData);
    } catch (e) {
      console.error("Error cargando clientes:", e);
      setClientes([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchClientes(); }, []);

  return (
    <Box sx={{ p: 0, m: 0 }}>
      <Box sx={{display:'flex',flexDirection:{xs:'column',sm:'row'},alignItems:{xs:'flex-start',sm:'center',gap:2},justifyContent:'space-between'}}>
        <Box sx={{mr:2}}>
          <Typography variant='h6'>Administración de Clientes</Typography>
          <Typography variant='body1' color='textSecondary'>Gestiona clientes y administra tu base de clientes</Typography>
        </Box>
        <Box sx={{width:{xs:'100%',sm:'auto'}}}>
          <Nuevocliente refresh={fetchClientes}/>
        </Box>
      </Box>

        <TableContainer component={Paper}  sx={{mt:3, maxHeight: 590,
            borderRadius: 3,
            border:`1px solid ${grey[400]}`,
            overflowX: 'auto' , '&::-webkit-scrollbar': {
            display: 'none',
            },
            // Ocultar para Firefox
            scrollbarWidth: 'none',
            // Ocultar para Internet Explorer y Edge antiguo
            msOverflowStyle: 'none',}}>

          <Table  sx={{minWidth: 200 }} stickyHeader aria-label="customized table" >
          <TableHead sx={{ bgcolor: grey[100] }}>
            <TableRow >
              <StyledTableCell sx={{fontWeight:'bold'}}>Empresa</StyledTableCell>
              <StyledTableCell sx={{fontWeight:'bold'}}>Contacto</StyledTableCell>
              <StyledTableCell sx={{fontWeight:'bold'}}>Email / Teléfono</StyledTableCell>
              <StyledTableCell sx={{fontWeight:'bold'}}>Direción</StyledTableCell>
              <StyledTableCell sx={{fontWeight:'bold'}}>Equipo/Soluciones</StyledTableCell>
              <StyledTableCell sx={{fontWeight:'bold'}} align='right' >Acciones</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={5} sx={{ py: 10 }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <CircularProgress size={40} sx={{ color: grey[500] }} />
                    <Typography sx={{ mt: 2, color: grey[600] }}>Cargando clientes...</Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ) : clientes.map((cliente) => (
              <TableRow  
                  hover 
                  key={cliente.id} 
                  sx={{ 
                  '&:last-child td, &:last-child th': { border: 0 },
                  height: '60px' // Forzamos una altura consistente para todas las filas
                }}
              >
                {/* Columna Rol: Alineación perfecta con altura controlada */}
                <TableCell>
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    lineHeight: 1, // Evita que el texto empuje el alto de la celda
                    gap: 1 
                  }}>
                    <StorefrontOutlinedIcon/>
                    <Typography variant="body2">
                      {cliente.empresa}
                    </Typography>
                  </Box>
                </TableCell>

                <TableCell variant='body'>{cliente.nombre}</TableCell>

                <TableCell align="left">
                    <Box sx={{ display: 'flex', flexDirection:'column',lineHeight: 1,gap:0.5}}>
                            <Box sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                lineHeight: 1}}>
                                <MailOutlineIcon sx={{ fontSize: '1.25rem',mx:1 }}/>{cliente.email}
                            </Box>
                            <Box sx={{ 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    lineHeight: 1, 
                                    }}>
                                <PhoneEnabledOutlinedIcon sx={{ fontSize: '1.25rem',mx:1 }}/>
                                { `+52 ${cliente.phone}` }
                            </Box>
                    </Box>
                </TableCell>

                <TableCell variant='body'>
                  <Box sx={{ display: 'flex', flexDirection:'row'}}>   
                    <LocationOnOutlinedIcon sx={{ fontSize: '1.25rem',mx:1 }}/>
                    <Typography>{cliente.direccion}</Typography>        
                  </Box>
                </TableCell>

                <TableCell variant='body'>

                    <Celda permisosArray={cliente.equipo}></Celda>

                </TableCell>

                <TableCell align="center" sx={{width:100}}>
                  <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                      <Editarcliente cliente={cliente} refresh={fetchClientes} />
                      <Deletecliente cliente={cliente} refresh={fetchClientes} />
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          </Table>
        </TableContainer>

    </Box>
  );
}